module.exports = __webpack_public_path__ + "img/connexion.bc5bbec6.png";